import { inject, Injectable } from '@angular/core';
import { CrossSiteRequestForgeryService, CSRFResponse, WindowRef } from '@spartacus/core';


@Injectable({
  providedIn: 'root',
})
export class CustomCsrfService extends CrossSiteRequestForgeryService {
  winRef = inject(WindowRef);
  override getCsrfToken() {

    const url = this.authConfigService.getCsrfEndpoint();
     return this.http.get<CSRFResponse>(url, {  
      withCredentials: true,  
      headers: {  
        Origin: this.winRef.nativeWindow?.location.origin ?? '',  
      },  
    });  
  }
}